import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { AbsencePeriodCreate } from './AbsencePeriodCreate';
import { AbsencePeriodDelete } from './AbsencePeriodDelete';
import { AbsencePeriodDisplay } from './AbsencePeriodDisplay';
import { AbsencePeriodSearch } from './AbsencePeriodSearch';
import { AbsencePeriodUpdate } from './AbsencePeriodUpdate';
import { AbsencePeriodUserDisplay } from './AbsencePeriodUserDisplay';
import { Four04 } from 'gossamer-front-end';

export const AbsenceRoutes = (): React.JSX.Element => (
  <Routes>
    <Route path="/create" element={<AbsencePeriodCreate />} />
    <Route path="/delete/:key" element={<AbsencePeriodDelete />} />
    <Route path="/display/:key" element={<AbsencePeriodDisplay />} />
    <Route path="/search" element={<AbsencePeriodSearch />} />
    <Route path="/update/:key" element={<AbsencePeriodUpdate />} />
    <Route path="*" element={<Four04 />} />
  </Routes>
);

export const AbsencePeriodUserRoutes = (): React.JSX.Element => (
  <Routes>
    <Route path="/display/:key" element={<AbsencePeriodUserDisplay />} />
    <Route path="*" element={<Four04 />} />
  </Routes>
);
